import { Box, VStack, HStack, Image, Text, useBreakpointValue } from "@chakra-ui/react";

const BigTestimonial = () => {
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm' || breakpoint === 'md';

    const bioTextJohn = "JustifyAI is clearly my choice for using AI in my company's Investigation practices. " +
        "I have tried many other companies and JustifyAI by far surpasses my expectations. " +
        "JustifyAI is catered for use in Private Investigations along with utilization for Body Worn Cameras. " +
        "This has truly made my investigation process easier and has cut production time in half. The information obtained is clear and concise. " +
        "I have also had great responses from JustifyAI when I have had questions or concerns, " +
        "they are fast to react and fix any issues and are also open to changes when I have discussed with them to assist in my daily operations. " +
        "Definitely a Must to have."

    const bioTextRandall = "Justify AI is how I gain the upper hand. It sharpens my findings, accelerates case prep and gives my attorneys " +
        "the clarity they need to dominate in court. It's a force multiplier, plain and simple."

    const cardStyles = {
        bg: "white",
        borderRadius: "xl",
        boxShadow: "xl",
        border: "2px solid",
        borderColor: "gray.100",
        p: [6, 7, 8],
        transition: "all 0.3s ease",
        _hover: {
            transform: "translateY(-4px)",
            boxShadow: "2xl",
        }
    };

    return (
        <Box width={['84%','85%', '81%', '73%', '61%']} mx="auto">
            <VStack spacing={8}>
                {/* First Testimonial Card */}
                <Box {...cardStyles} w="100%">
                    <VStack
                        align={'center'}
                        justify={'center'}
                        spacing={6}
                        flexDirection={isMobile ? "column" : "row"}
                    >
                        {/** When not in mobile, image on the left */}
                        {!isMobile && (
                            <Image
                                src="/Aimpoint_Logo.png"
                                alt="John Miller Testimonial"
                                borderRadius={20}
                                objectFit={'cover'}
                                // boxSize={['120px', '140px', '160px', '180px']}
                                w={{ base: "190px", md: "230px", lg: "230px" }}
                                h="auto"
                            />
                        )}

                        <Box flex="1">
                            <Text
                                fontSize={[14, 15, 16, 15, 16, 18]}
                                fontWeight={500}
                                textAlign={"left"}
                                lineHeight="1.6"
                                color="gray.700"
                                mb={6}
                            >
                                "{bioTextJohn}"
                            </Text>
                            <HStack
                                align="center"
                                justify={"flex-start"}
                            >
                                {/** When in mobile, image on the left */}
                                {isMobile && (
                                    <Image
                                        borderRadius={20}
                                        src="/Aimpoint_Logo.png"
                                        alt="John Miller Testimonial"
                                        // boxSize={['60px', '70px', '80px']}
                                        w={{ base: "190px", md: "230px", lg: "230px" }}
                                        h="auto"
                                        objectFit="cover"
                                        mr={4}
                                    />
                                )}
                                <VStack align={"flex-start"} spacing={1}>
                                    <Text fontWeight="bold" textAlign={'left'} fontSize={[15, 16, 17]} color="gray.800">
                                        John Miller
                                    </Text>
                                    <Text fontSize={[13, 14, 15]} color="gray.500" textAlign={'left'}>
                                        President and Criminal Investigator - Arizona
                                    </Text>
                                </VStack>
                            </HStack>
                        </Box>
                    </VStack>
                </Box>

                {/* Second Testimonial Card */}
                <Box {...cardStyles} w="100%">
                    <VStack
                        align={'center'}
                        justify={'center'}
                        spacing={6}
                        flexDirection={isMobile ? "column" : "row"}
                    >
                        {/** When not in mobile, image on the left */}
                        {!isMobile && (
                            <Image
                                src="/deepsight_logo.jpg"
                                alt="Randall Roby Testimonial"
                                borderRadius={20}
                                objectFit={'cover'}
                                w={{ base: "190px", md: "230px", lg: "230px" }}
                                h="auto"
                                // w={['120px', '140px', '160px', '180px']}
                                // h={['120px', '140px', '160px', '180px']}
                            />
                        )}

                        <Box flex="1">
                            <Text
                                fontSize={[14, 15, 16, 15, 16, 18]}
                                fontWeight={500}
                                textAlign={"left"}
                                lineHeight="1.6"
                                color="gray.700"
                                mb={6}
                            >
                                "{bioTextRandall}"
                            </Text>
                            <HStack
                                align="center"
                                justify={"flex-start"}
                            >
                                {/** When in mobile, image on the left */}
                                {isMobile && (
                                    <Image
                                        borderRadius={20}
                                        src="/deepsight_logo.jpg"
                                        alt="Randall Roby Testimonial"
                                        // boxSize={['60px', '70px', '80px']}
                                        w={{ base: "190px", md: "230px", lg: "230px" }}
                                        h="auto"
                                        objectFit="cover"
                                        mr={4}
                                    />
                                )}
                                <VStack align={"flex-start"} spacing={1}>
                                    <Text fontWeight="bold" textAlign={'left'} fontSize={[15, 16, 17]} color="gray.800">
                                        Randall Roby
                                    </Text>
                                    <Text fontSize={[13, 14, 15]} color="gray.500" textAlign={'left'}>
                                        Owner & Principal Investigator - Tennessee
                                    </Text>
                                </VStack>
                            </HStack>
                        </Box>
                    </VStack>
                </Box>
            </VStack>
        </Box>
    );
};

export default BigTestimonial;
